import type { Market } from "@ferrivia/api-contract";

// The only booking surfaces — no in-app scheduling. Named consts rather than on the wire.
export const SYDANKESKUS_BOOKING_URL = "https://sydankeskus.mbooking.fi/ajanvaraus";

export const MARI_BOOKING_URL =
  "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ3n1IIzRLaMr7prMO0-0nYNxgW0ogEu4Uwea2a8GFqkHxssq4IIbsgFB4doMl6H1TNKyQZ6xbKx";

// TODO: placeholder until Mari's US appointment schedule exists; swap this one line.
export const MARI_BOOKING_URL_US = "https://calendar.google.com/calendar/u/0/appointments/schedules/PLACEHOLDER-US";

export function coachBookingUrl(market: Market): string {
  return market === "us" ? MARI_BOOKING_URL_US : MARI_BOOKING_URL;
}
